import {encodeBase64, REDIRECT_URL_KEY} from 'global';
import {defaultTo} from 'lodash';
import React, {ReactNode, useEffect, useMemo} from 'react';
import {useSelector} from 'react-redux';
import {Navigate, useLocation} from 'react-router-dom';
import {appRoutes} from 'routes/config';
import {sessionSelector} from 'store/auth/sessionSlice';

interface AuthenticationGuardProps {
    layout: ReactNode;
}
export const AuthenticationGuard: React.FC<AuthenticationGuardProps> = ({layout}) => {
    const location = useLocation();
    const {jwtToken, tenantSlug, workspaceSlug, boardSlug} = useSelector(sessionSelector);
    // const navigate = useNavigate();
    const isAuthPage = location.pathname.startsWith('/auth');
    useEffect(() => {
        console.log('JWT Token:', jwtToken);
        console.log('Tenant Slug:', tenantSlug);
        console.log('Workspace Slug:', workspaceSlug);
        console.log('Board Slug:', boardSlug);
    }, [jwtToken, tenantSlug, workspaceSlug, boardSlug]);
    // Generate encoded URL only if not logging out
    const encodedUrl = useMemo(
        () => encodeBase64(`${location.pathname}${defaultTo(location.search, '')}`),
        [location.pathname, location.search],
    );

    const loginPagePath = useMemo(() => `${appRoutes.auth.loginIn()}?${REDIRECT_URL_KEY}=${encodedUrl}`, [encodedUrl]);

    const isAuthenticated = () => {
        return !!jwtToken;
    };

    if (location.pathname === '/' && isAuthenticated()) {
        return <Navigate to={appRoutes.workspace.boardListing(tenantSlug, workspaceSlug, boardSlug)} />;
    }

    // If an unauthenticated user is on '/auth', redirect them to '/auth/login'
    if (!isAuthenticated() && location.pathname === '/auth') {
        return <Navigate to={loginPagePath} />;
    }

    // Allow users to navigate freely within authentication pages (login, signup, forgot-password)
    if (!isAuthenticated() && isAuthPage) {
        return <>{layout}</>;
    }

    // Redirect unauthenticated users trying to access protected routes to login
    if (!isAuthenticated()) {
        return <Navigate to={loginPagePath} />;
    }

    return <>{layout}</>;
};

export default AuthenticationGuard;
